export const SEARCH_BODY_SCANS_REQUEST = 'BODY_SCANS/SEARCH/REQUEST';
export const SEARCH_BODY_SCANS_SUCCESS = 'BODY_SCANS/SEARCH/SUCCESS';

export const OPEN_BODY_SCANS_IMPORT_MODAL = 'BODY_SCANS/SEARCH/OPEN_MODAL';
export const CLOSE_BODY_SCANS_IMPORT_MODAL = 'BODY_SCANS/SEARCH/CLOSE_MODAL';
